module.exports = __webpack_public_path__ + "img/entertainment-7-640.79fcf55a.jpg";